import type { MutationOptions } from "@tanstack/react-query";

/**
 * Mutations rodam mesmo sem rede (`networkMode: "always"`): no padrão ("online"), o TanStack Query pausaria um
 * salvamento feito offline e o enviaria sozinho quando a rede voltasse — uma fila de envio escondida, proibida no
 * Nora (M1, item 13). Assim o `api/client` falha na hora com `offline` e a tela diz que nada foi salvo.
 * As consultas seguem "online": sem rede ficam pausadas com o último dado e recarregam quando a rede volta.
 */
export const MUTATION_DEFAULTS = { networkMode: "always" } satisfies MutationOptions;
